/**
 * Checks if string represents dev ot test mode
 * @param  {String} mode
 * @return {Boolean coercible}
 *
 * @example
 * isDev('dev') // true
 * isDev('prod') // false
 */
export default (mode) => mode && /^dev|^test/i.test(mode);
